import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { companyInfo } from '../data/mock';
import HeaderContactInfo from './Header/HeaderContactInfo';
import DesktopNav from './Header/DesktopNav';
import HeaderCTA from './Header/HeaderCTA';
import MobileMenu from './Header/MobileMenu';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="header-container">
      <div className="header-content">
        <div className="header-logo">
          <img src={companyInfo.logo} alt={companyInfo.name} className="logo-image" />
        </div>

        <HeaderContactInfo
          phone={companyInfo.contact.phone}
          email={companyInfo.contact.email}
        />

        <DesktopNav onNavigate={scrollToSection} />

        <HeaderCTA />

        <button
          className="mobile-menu-button"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {mobileMenuOpen && <MobileMenu onNavigate={scrollToSection} />}
    </header>
  );
};

export default Header;
